// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import productCategory from "../../helpers/productCategory";
import { MdOutlineAddToDrive } from "react-icons/md";
import { AiOutlineCloseCircle } from "react-icons/ai";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import DisplayImageProduct from "../displayImageProduct.js/displayImageProduct";
import { toast, ToastContainer } from "react-toastify";
// eslint-disable-next-line
import "react-toastify/dist/ReactToastify.css";
import uploadImage from "../../helpers/uploadImage";
import axios from "axios";
import summaryApi from "../../common/Api";
import Cookies from "js-cookie";

const EditProduct = ({ onClose, fetchProducts, productId }) => {
  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    category: "",
    product_image: [],
    price: "",
    discount: "",
    quantity: "",
    description: "",
  });

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const tokenApi = Cookies.get("tokenApi");
        if (!tokenApi) {
          toast.error("Authentication token is missing. Please log in again.", {
            position: "bottom-center",
            className: "custom-toast",
            autoClose: 2000,
            draggable: true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggablePercent: 60,
          });
          return;
        }
        const formDataObj = new FormData();
        Object.keys(formData).forEach((key) => {
          if (Array.isArray(formData[key])) {
            formData[key].forEach((item) => formDataObj.append(key, item));
          } else {
            formDataObj.append(key, formData[key]);
          }
        });

        // console.log("productId:", productId);

        // Check if productId is an object and if so, extract the correct value
        const validProductId =
          typeof productId === "object"
            ? productId._id || productId.id
            : productId;

        // Log the validProductId to check its value
        // console.log("validProductId:", validProductId);

        // Make sure validProductId is correctly formed
        if (!validProductId) {
          toast.error("Invalid product ID", {
            position: "bottom-center",
            className: "custom-toast",
            autoClose: 2000,
            draggable: true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggablePercent: 60,
          });
          return;
        }

        const response = await axios.get(
          summaryApi.getProductDetails(validProductId).url,
          {
            headers: {
              Authorization: `Bearer ${tokenApi}`,
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        // console.log("Product Details:", response.data.data); // Log the response data

        const product = response.data.data; //
        setFormData({
          name: product.name || "",
          brand: product.brand || "",
          category: product.category || "",
          price: product.price || "",
          discount: product.discount || "",
          quantity: product.quantity || "",
          description: product.description || "",
          product_image: product.product_image || [],
        });
      } catch (error) {
        // console.error("حدث خطأ أثناء جلب تفاصيل المنتج", error);
        console.error("Error retrieving product details", error);
        toast.error("Error retrieving product details.", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        // toast.error("فشل في جلب تفاصيل المنتج.");
      }
    };

    if (productId) {
      fetchProductDetails();
    }
  }, [productId]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [openImage, setOpenImage] = useState(false);

  const editProduct = async (formData) => {
    try {
      const tokenApi = Cookies.get("tokenApi");
      if (!tokenApi) {
        toast.error("Authentication token is missing. Please log in again.", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }

      // console.log("Editing product:", formData);

      await axios.patch(
        summaryApi.editProduct(productId).url,
        {
          name: formData?.name,
          brand: formData?.brand,
          category: formData?.category,
          price: formData?.price,
          discount: formData?.discount,
          quantity: formData?.quantity,
          description: formData?.description,
          product_image: formData?.product_image,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      // console.log("Product updated successfully", response.data);
    } catch (error) {
      console.error("Error checking authentication token:", error);
      toast.error(
        "An error occurred while checking authentication. Please try again.",
        {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        }
      );
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // console.log("Form Data:", formData);
      editProduct(formData);
      fetchProducts();
      toast.success("Product updated successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });

      await editProduct();
      fetchProducts();
      toast.success("Product uploaded successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      onClose();
    } catch (error) {
      toast.error("Error uploading product", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/webp",
      "image/gif",
      "image/bmp",
      "image/tiff",
    ]; // Add more types if needed

    try {
      const uploadedImages = await Promise.all(
        files.map((file) => {
          if (validImageTypes.includes(file.type)) {
            return uploadImage(file);
          } else {
            throw new Error("Invalid file type. Only images are allowed.");
          }
        })
      );

      setFormData((prevState) => ({
        ...prevState,
        product_image: [...prevState.product_image, ...uploadedImages],
      }));

      toast.success("Images uploaded successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      toast.error(error.message, {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  const handleRemoveImage = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product_image: prevState.product_image.filter((_, i) => i !== index),
    }));
    toast.success("Image removed", {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
    });
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setFormData({
      ...formData,
      category: selectedCategory,
    });
  };

  useEffect(() => {
    toast.info("You must fill in all fields", {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
    });
  }, [fetchProducts]);

  return (
    <div className="relative p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-semibold text-xl">Update Product</h2>
        <span className="hover:text-red-600 cursor-pointer" onClick={onClose}>
          <RiCloseLargeFill />
        </span>
      </div>

      <form className="space-y-4 pt-4" onSubmit={handleSubmit}>
        <div>
          <label
            htmlFor="name"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Product Name:
          </label>
          <input
            onChange={handleChange}
            type="text"
            id="name"
            name="name"
            value={formData.name}
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[35px] transition-all"
            placeholder="Enter the Product Name"
            required
          />
        </div>

        <div>
          <label
            htmlFor="brand_name"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Brand Name:
          </label>
          <input
            onChange={handleChange}
            value={formData.brand}
            type="text"
            id="brand_name"
            name="brand"
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[35px] transition-all"
            placeholder="Enter the Brand Name"
            required
          />
        </div>

        <div>
          <label
            htmlFor="category"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Category:
          </label>
          <select
            onChange={handleCategoryChange}
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[40px] transition-all"
            name="category"
            id="category"
            required
          >
            <option value="">Select Category</option>

            {productCategory.map((category, index) => (
              <option key={index} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="product_image"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Product Image:
          </label>

          <label
            style={{ outline: "1px solid #00000000" }}
            className="flex items-center flex-col gap-4 text-gray-500 bg-slate-100 p-5 cursor-pointer rounded-md "
          >
            <input
              onChange={handleImageChange}
              accept="image/*"
              multiple
              type="file"
              id="product_image"
              name="product_image"
              className=" mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[40px] transition-all hidden"
              required
            />
            <span className="text-3xl">
              <MdOutlineAddToDrive />
            </span>
            <p>Upload Product Image</p>
          </label>
        </div>

        <div className="flex gap-5 flex-wrap">
          {formData.product_image.map((image, index) => (
            <div
              key={index}
              className="flex flex-col gap-2 relative hover:scale-105 transition-all duration-300"
            >
              <img
                src={image}
                alt="product_image"
                className="w-[100px] h-[100px] object-cover cursor-zoom-in"
                onClick={() => {
                  setSelectedImage(image);
                  setOpenImage(true);
                }}
              />

              <span
                className="text-red-600 text-xl cursor-pointer absolute -top-2 -left-2 "
                onClick={() => handleRemoveImage(index)}
              >
                <AiOutlineCloseCircle />
              </span>
            </div>
          ))}
        </div>

        <div>
          <label
            htmlFor="price"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Price:
          </label>
          <input
            onChange={handleChange}
            value={formData.price}
            type="number"
            id="price"
            name="price"
            min={0}
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[35px] transition-all"
            placeholder="Enter the Price"
            required
          />
        </div>

        <div>
          <label
            htmlFor="discount"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Discount Price:
          </label>
          <input
            onChange={handleChange}
            value={formData.discount}
            type="string"
            id="discount"
            name="discount"
            min={0}
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[35px] transition-all"
            placeholder="Enter the discount price"
            required
          />
        </div>

        <div>
          <label
            htmlFor="quantity"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Quantity Product:
          </label>
          <input
            onChange={handleChange}
            value={formData.quantity}
            type="number"
            id="quantity"
            name="quantity"
            min={0}
            className="mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[35px] transition-all"
            placeholder="Enter the quantity product"
            required
          />
        </div>

        <div>
          <label
            htmlFor="description"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Description:
          </label>
          <textarea
            onChange={handleChange}
            value={formData.description}
            id="description"
            name="description"
            rows={4}
            className=" resize-none mt-1 p-2 border border-gray-300 bg-slate-100 rounded-md w-full outline-none h-[150px] transition-all"
            placeholder="Enter the Description"
            required
          ></textarea>
        </div>

        <button className="bg-main-background py-2 px-2 mt-7 mx-auto block rounded-md text-white ">
          Update Product
        </button>
      </form>

      {openImage && (
        <DisplayImageProduct
          onClose={() => setOpenImage(false)}
          image={selectedImage}
        />
      )}

      <ToastContainer />
    </div>
  );
};

export default EditProduct;
